
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`La deuxième vague`}</h2>
    <p>{`Lors de la deuxième vague, de début juin 2020 à fin février 2021, les communes du sud de la Suisse proches de la frontière sont à nouveau davantage touchées par le virus. De nouveaux clusters sont identifiés cette fois en Suisse orientale. La Suisse romande enregistre un nombre particulièrement élevé d'infections. Selon les chiffres de l'OFSP, le bilan de la deuxième vague s’élève à plus de 500'000 cas confirmés et 8000 décès. Dans de nombreux cantons, tous les lits en soins intensifs ont été, à un moment ou un autre, occupés.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;